import styles from "./InfoCard.module.css";

function renderIcon(icon, medal) {
  return (
    <div className="flex">
      {medal ? (
        icon
      ) : (
        <div
          className={`flex items-center justify-center 
text-lg p-4 md:p-5 md:ml-1 md:text-2xl rounded-full
bg-altgray-50 text-altgray-700 `}
        >
          {icon}
        </div>
      )}
    </div>
  );
}

export default function InfoCard({
  title = null,
  icon = null,
  children = null,
  medal = false,
}) {
  return (
    <div
      className={`relative flex w-full md:rounded-t-xl h-24 md:h-32 text-white
      pl-5 md:pl-6 ${styles.header}`}
    >
      <div className="flex items-center w-full space-x-3 md:space-x-4 ">
        {icon && renderIcon(icon, medal)}
        <div className={`flex flex-col w-full space-y-1.5 md:space-y-2.5`}>
          <div className="flex items-center w-full space-x-1 text-xl font-semibold capitalize rounded-t-xl border-altgray-100">
            {title}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
